<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ testQuestion ? 'Edit Test Question' : 'Add Test Question' }}
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Content">
          <d-input v-model="testQuestionForm.content" type="textarea" required />
        </d-field>
        <d-field label="Citation">
          <d-input v-model="testQuestionForm.citation" required />
        </d-field>
        <d-field label="Page Number">
          <d-input v-model="testQuestionForm.pageNumber" required />
        </d-field>
        <div class="text-primary-500 text-lg mr-3">
          Test Question Answers:
        </div>
        <div class="flex space-x-4">
          <d-field label="Test Question Answer #1" class="w-3/4">
            <d-input v-model="testQuestionForm.answerOne" type="textarea" />
          </d-field>
          <d-field label="Is Correct?">
            <input v-model="testQuestionForm.answerOneCorrect" name="answerCorrect" type="checkbox" @click="setCorrectAnswer(0)">
          </d-field>
        </div>
        <div class="flex space-x-4">
          <d-field label="Test Question Answer #2" class="w-3/4">
            <d-input v-model="testQuestionForm.answerTwo" type="textarea" />
          </d-field>
          <d-field label="Is Correct?">
            <input v-model="testQuestionForm.answerTwoCorrect" name="answerCorrect" type="checkbox" @click="setCorrectAnswer(1)">
          </d-field>
        </div>
        <div class="flex space-x-4">
          <d-field label="Test Question Answer #3" class="w-3/4">
            <d-input v-model="testQuestionForm.answerThree" type="textarea" />
          </d-field>
          <d-field label="Is Correct?">
            <input v-model="testQuestionForm.answerThreeCorrect" name="answerCorrect" type="checkbox" @click="setCorrectAnswer(2)">
          </d-field>
        </div>
        <div class="flex space-x-4">
          <d-field label="Test Question Answer #4" class="w-3/4">
            <d-input v-model="testQuestionForm.answerFour" type="textarea" />
          </d-field>
          <d-field label="Is Correct?">
            <input v-model="testQuestionForm.answerFourCorrect" name="answerCorrect" type="checkbox" @click="setCorrectAnswer(3)">
          </d-field>
        </div>
        <div class="flex space-x-4">
          <d-field label="Test Question Answer #5" class="w-3/4">
            <d-input v-model="testQuestionForm.answerFive" type="textarea" />
          </d-field>
          <d-field label="Is Correct?">
            <input v-model="testQuestionForm.answerFiveCorrect" name="answerCorrect" type="checkbox" @click="setCorrectAnswer(4)">
          </d-field>
        </div>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Close
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Save Changes
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  import axios from 'axios';

  export default {
    props: {
      testQuestion: {
        type: Object,
        default: null,
      },
      testSectionId: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        correctAnswerIndex: null,
        saving: false,
        answers: [],
        loadingData: false,
        total: 0,
        filter: '',

        pagination: {
          page: 1,
          pageSize: 50,
          sortField: 'content',
          sortOrder: 'asc',
        },
        testQuestionForm: {
          content: '',
          citation: '',
          pageNumber: '',
          previousVersionId: null,
          testSectionId: 0,
          answerOne: '',
          answerTwo: '',
          answerThree: '',
          answerFour: '',
          answerFive: '',
          answerOneCorrect: false,
          answerTwoCorrect: false,
          answerThreeCorrect: false,
          answerFourCorrect: false,
          answerFiveCorrect: false,
        },
      };
    },


    mounted() {
      if (this.testQuestion) {
        this.testQuestionForm = JSON.parse(JSON.stringify(this.testQuestion));
        this.testQuestionForm.previousVersionId = this.testQuestion.id;
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        this.testQuestionForm.testSectionId = this.testSectionId;
        try {
          await axios.post('/api/testQuestions/', this.testQuestionForm);
          this.$toast.open({
            message: 'Test Question has been saved',
            color: 'success',
          });

          await this.$parent.events.getAnswersForQuestions();
          this.$parent.close();
        } catch (error) {
          this.$toast.error({ message: error.response.data[0] });
        } finally {
          this.saving = false;
        }
      },

      setCorrectAnswer(correctAnswer) {
        this.correctAnswerIndex = correctAnswer;
        this.testQuestionForm.answerOneCorrect = this.correctAnswerIndex === 0;
        this.testQuestionForm.answerTwoCorrect = this.correctAnswerIndex === 1;
        this.testQuestionForm.answerThreeCorrect = this.correctAnswerIndex === 2;
        this.testQuestionForm.answerFourCorrect = this.correctAnswerIndex === 3;
        this.testQuestionForm.answerFiveCorrect = this.correctAnswerIndex === 4;
      },
    },
  };
</script>